<template>
  <div class="container" style="flex: 1">
    <div v-show="showUp" ref="up" :style="up">
      <slot name="up" />
    </div>
    <div
      v-show="showUp&&showDown"
      ref="division"
      class="division"
      :style="{height:divisionH+'px'}"
      @mousedown="enabled=true"
    >
      <div class="line" style="margin-top:2px" />
      <div class="line" />
    </div>
    <div v-show="showDown" ref="down" :style="down">
      <slot name="down" />
    </div>
  </div>
</template>

<script>
import { DocumentManage } from '@/utils/commonUtil'

export default {
  name: 'CargoUpDownResize',
  props: {
    showUp: {
      type: Boolean,
      default: true
    },
    upStyle: {
      type: Object,
      default: () => { return {} }
    },
    showDown: {
      type: Boolean,
      default: true
    },
    downStyle: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      enabled: false,
      divisionH: 8,
      doc: new DocumentManage()
    }
  },
  computed: {
    divisionHalfH() {
      return this.divisionH / 2
    },
    up() {
      return Object.assign({ flex: 'auto', overflowY: 'auto' }, this.upStyle)
    },
    down() {
      return Object.assign({ flex: 'auto', overflowY: 'auto' }, this.downStyle)
    }
  },
  created() {
    this.doc.set('dragging', e => {
      if (!this.enabled) {
        return
      }
      this.dragging(e)
    })
    this.doc.set('endDrag', () => {
      document.getElementById('app').classList.remove('disabled-select')
      this.enabled = false
    })
    this.doc.set('windowResize', () => {
      if (this.$refs.up && this.showUp && this.$refs.down && this.showDown) {
        if (this.upStyle.height) {
          this.$refs.up.style.height = this.upStyle.height
        } else {
          this.$refs.up.style.height = ''
        }
        if (this.downStyle.height) {
          this.$refs.down.style.height = this.downStyle.height
        } else {
          this.$refs.down.style.height = ''
        }
      }
    })
  },
  mounted() {
    document.addEventListener('mousemove', this.doc.get('dragging'), false)
    document.addEventListener('mouseup', this.doc.get('endDrag'), false)
    document.addEventListener('mouseleave', this.doc.get('endDrag'), false)
    // window.addEventListener('resize', this.doc.get('windowResize'))
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.doc.get('dragging'), false)
    document.removeEventListener('mouseup', this.doc.get('endDrag'), false)
    document.removeEventListener('mouseleave', this.doc.get('endDrag'), false)
    // window.removeEventListener('resize', this.doc.get('windowResize'))
    this.doc.destory()
  },
  methods: {
    dragging(e) {
      document.getElementById('app').classList.add('disabled-select')
      const up = this.$refs.up
      const upRect = up.getBoundingClientRect()
      const down = this.$refs.down
      const downRect = down.getBoundingClientRect()
      if (e.clientY <= upRect.up + this.divisionHalfH) {
        return
      }
      if (e.clientY >= downRect.down - this.divisionHalfH) {
        return
      }
      const upH = (e.clientY - this.divisionHalfH) - upRect.top
      const downH = downRect.bottom - (e.clientY + this.divisionHalfH)
      up.style.height = upH + 'px'
      down.style.height = downH + 'px'
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
}
.division {
  border-radius: 2px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  cursor: ns-resize;
}
.division .line {
  width: 18px;
  height: 0px;
  margin: 0 auto 1px auto;
  border-bottom: 2px solid #bdbdbd;
}
</style>
